import { getData } from "@/lib/request";

export const listHistoryLog = (params) => getData("web/history_log/getListHistoryLog", params);
export const countHistoryLog = (params) => getData("web/history_log/countHistoryLog", params);
